import type { CustomizationOpportunityContext } from "../types";

/** 读取从商机新增定制的预填上下文。 */
export function fetchCustomizationOpportunityContext(
  opportunityId: number,
): Promise<CustomizationOpportunityContext> {
  return import("../repo/customizationRepo").then(
    ({ fetchCustomizationOpportunityContext: fetchOpportunityContext }) =>
      fetchOpportunityContext(opportunityId),
  );
}